import { Component, OnInit } from '@angular/core';
import { from, Subject } from 'rxjs';
import { APIService } from '../../../../app/api.service';
import { MatSelect } from '@angular/material/select';
import { CommonService } from '../../../services/common.service'
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.scss']
})
export class PrintComponent implements OnInit {

  AgencyName = '';
  jarvisData: any = [];
  LedgerRecord: any = [];
  HeadRecord: any = [];
  AccurateProfitOrLoss: any = [];
  profitAndLossParameters: any = [];
  ProfitOrLoss: number = 0;
  GrandIncome: number = 0;
  GrandExpense: number = 0;
  IncomeArray: any = [];
  ExpenseArray: any = [];
  BindRecordLeft: any = [];
  BindRecordRight: any = [];
  profitLoss: any = [];
  selectedFY: any;
  financialYears: any = []; 
  expand: boolean = true;
  hideZeroLevelLdgr: boolean = true;
  fromDate: any;
  toDate: any;
  selectedDate: any;
  imBaalance: any;
  rightBal: any;
  leftBal: any;
  acctStartDT: Date = new Date("2020");
  isShowLiabilities: boolean = true;
  isShowAssets: boolean = true;
  agencyData: any = [];

  constructor(private apiService: APIService,private commonService: CommonService, private titleSer: Title) { }

  ngOnInit(): void {
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    let jarvis = this.apiService.getCookie("Jarvis");
        if (jarvis) {
            this.jarvisData = JSON.parse(jarvis);
      };
      this.getData();

      setTimeout(() => {
        this.titleSer.setTitle("BalanceSheet - Biziverse");
      }, 200);
  }

  //getData() - Get Balanceshet data
  getData(){
    this.fromDate = this.commonService.GetParam('FDT');
    this.toDate = this.commonService.GetParam('TDT');
    this.AgencyName = this.agencyData[0].AgencyName;
    
    let data = [{
      fromDT: new Date(this.fromDate).customFormat("#DD#-#MMM#-#YY#"),
      toDT: new Date(this.toDate).customFormat("#DD#-#MMM#-#YY#")
    }]

    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'get',
        moduleID: 1,
        data: JSON.stringify(data)
    }];

    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));  
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    else {
        alert(res.message);
    }
  }

  //successResp - success  get handler
  successResp(res: any) {
    if (res.error) {
    }
    else {
        if (res) {
          var reponseData = JSON.parse(res.updatePackage);
          this.LedgerRecord = reponseData.Table1;
          this.HeadRecord = reponseData.Table2;
          this.AccurateProfitOrLoss = reponseData.Table3;
          this.profitAndLossParameters = reponseData.Table4;
          this.fn_BindBalanceSheetData();
        }
        this.printBalanceSheet();
    }
  }

  printBalanceSheet(){
    setTimeout(function () {
      var printArea = $('#balancesheet').html();
      $('body').html(printArea); 
      window.print(); 
  }, 1000);
  }

   //fn_BindBalanceSheetData() - Bind Data to balance sheet
   fn_BindBalanceSheetData(){
    this.ProfitOrLoss = 0;
    this.GrandIncome = 0;
    this.GrandExpense = 0;
    this.IncomeArray = [];
    this.ExpenseArray = [];
    let headID: number = 0;

    //Left side data bind
    for (let i = 0; i < this.HeadRecord.length; i++) {
      if(this.HeadRecord[i].ParentHeadID == 0 && this.HeadRecord[i].LedgerType == 2){
        headID = this.HeadRecord[i].HeadID;
        this.BindRecordLeft.push({
          HeadID: this.HeadRecord[i].HeadID,
          HeadName: this.HeadRecord[i].HeadName,
          CloBal: this.HeadRecord[i].CloBal,
          LedgerID: 0,
          SubHead: $.grep(this.HeadRecord, function (e: any) { return e.ParentHeadID == headID && e.LedgerType == 2 && e.CloBal != 0 }),
          Ledger: $.grep(this.LedgerRecord, function (e: any) { return e.HeadID == headID && e.CloBal != 0 })
        });
      };
             
    }

    //Right side data bind
    headID = 0;
    for (let i = 0; i < this.HeadRecord.length; i++) {
      if(this.HeadRecord[i].ParentHeadID == 0 && this.HeadRecord[i].LedgerType == 1){
        headID = this.HeadRecord[i].HeadID;
        this.BindRecordRight.push({
          HeadID: this.HeadRecord[i].HeadID,
          HeadName: this.HeadRecord[i].HeadName,
          CloBal: this.HeadRecord[i].CloBal,
          LedgerID: 0,
          SubHead: $.grep(this.HeadRecord, function (e: any) { return e.ParentHeadID == headID && e.LedgerType == 1 && e.CloBal != 0 }),
          Ledger: $.grep(this.LedgerRecord, function (e: any) { return e.HeadID == headID && e.CloBal != 0 })
        });
      };               
    }

    //Expense Data bind
    headID = 0;
    for (let i = 0; i < this.HeadRecord.length; i++) {
      if(this.HeadRecord[i].ParentHeadID == 0 && this.HeadRecord[i].LedgerType == 4){
          headID = this.HeadRecord[i].HeadID;
          this.ExpenseArray.push({
            HeadID: this.HeadRecord[i].HeadID,
            HeadName: this.HeadRecord[i].HeadName,
            CloBal: this.HeadRecord[i].CloBal,
            LedgerID: 0
          });
      };               
    }

    //Expense Data bind
    headID = 0;
    for (let i = 0; i < this.HeadRecord.length; i++) {
      if(this.HeadRecord[i].ParentHeadID == 0 && this.HeadRecord[i].LedgerType == 3){
          headID = this.HeadRecord[i].HeadID;
          this.IncomeArray.push({
            HeadID: this.HeadRecord[i].HeadID,
            HeadName: this.HeadRecord[i].HeadName,
            CloBal: this.HeadRecord[i].CloBal,
            LedgerID: 0
          });
      };               
    }

    if(this.LedgerRecord){
        this.profitLoss = $.grep(this.LedgerRecord, function (i: any) { return i.LedgerName == "Profit & Loss A/c" });
        if(this.profitLoss.length > 0){
            if(this.profitAndLossParameters){
              this.profitLoss[0].totalProfitAndLoss = this.profitAndLossParameters[0].TotalProfitLoss;
              this.profitLoss[0].openingProfitAndLoss = this.profitAndLossParameters[0].OpeningProfitLoss;
              this.profitLoss[0].currentProfitAndLoss = this.profitAndLossParameters[0].CurrentProfitLoss;
            };
        }
    }

    // Left Side
    var LrftSideArrayLength = this.BindRecordLeft.length;
      var LeftSideBalance:any = 0;
      for (var i = 0; i < LrftSideArrayLength; i++) {
          LeftSideBalance += parseFloat(String(this.BindRecordLeft[i].CloBal).replace(/\,/g, ""));
      }
      if (this.ProfitOrLoss > 0 && this.profitLoss.length == 0) {
          LeftSideBalance += parseFloat(String(this.ProfitOrLoss));
      }
      else if (this.profitLoss.length > 0 && this.profitLoss[0].totalProfitAndLoss < 0) {
          LeftSideBalance += parseFloat(String(this.profitLoss[0].totalProfitAndLoss));
      }

      if (!this.AccurateProfitOrLoss) {
          this.AccurateProfitOrLoss = [];
      }
      if (this.AccurateProfitOrLoss.length > 0) {
          LeftSideBalance += parseFloat(String(this.AccurateProfitOrLoss[0].AccruedProfit));
      }

    // Right Side
    var RightSideArrayLength = this.BindRecordRight.length;
      var RightSideBalance = 0;
      for (var i = 0; i < RightSideArrayLength; i++) {
          RightSideBalance += parseFloat(String(this.BindRecordRight[i].CloBal).replace(/\,/g, ""));
      }
      if (this.ProfitOrLoss < 0 && this.profitLoss.length == 0) {
          RightSideBalance += parseFloat(String(this.ProfitOrLoss));
      }
      else if (this.profitLoss.length > 0 && this.profitLoss[0].totalProfitAndLoss > 0) {
          RightSideBalance += parseFloat(String(this.profitLoss[0].totalProfitAndLoss));
      }
      if (this.AccurateProfitOrLoss.length > 0) {
          RightSideBalance += parseFloat(String(this.AccurateProfitOrLoss[0].AccruedLoss));
          RightSideBalance += parseFloat(String(this.AccurateProfitOrLoss[0].ClosingStock));
      }

      let lftBal = parseFloat(String(LeftSideBalance).replace(/\-/g, "")).toFixed(2);
      let rgtBal = parseFloat(String(RightSideBalance).replace(/\-/g, "")).toFixed(2);

      this.imBaalance = Number(lftBal) - Number(rgtBal);

      this.rightBal = parseFloat(String(RightSideBalance));
      this.leftBal = parseFloat(String(LeftSideBalance));
     
  }

}

declare global {
  interface Date {
    customFormat(formatString : any): string;
  }
}

// String Prototye
Date.prototype.customFormat = function(formatString : any) {
  var YYYY, YY, MMMM, MMM, MM, M, DDDD, DDD, DD, D, hhhh, hhh, hh, h, mm, m, ss, s, ampm, AMPM, dMod, th;
  YY = ((YYYY = this.getFullYear()) + "").slice(-2);
  MM = (M = this.getMonth() + 1) < 10 ? ('0' + M) : M;
  MMM = (MMMM = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][M - 1]).substring(0, 3);
  DD = (D = this.getDate()) < 10 ? ('0' + D) : D;
  DDD = (DDDD = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][this.getDay()]).substring(0, 3);
  th = (D >= 10 && D <= 20) ? 'th' : ((dMod = D % 10) == 1) ? 'st' : (dMod == 2) ? 'nd' : (dMod == 3) ? 'rd' : 'th';
  formatString = formatString.replace("#YYYY#", YYYY).replace("#YY#", YY).replace("#MMMM#", MMMM).replace("#MMM#", MMM).replace("#MM#", MM).replace("#M#", M).replace("#DDDD#", DDDD).replace("#DDD#", DDD).replace("#DD#", DD).replace("#D#", D).replace("#th#", th);
  h = (hhh = this.getHours());
  if (h == 0) h = 24;
  if (h > 12) h -= 12;
  hh = h < 10 ? ('0' + h) : h;
  hhhh = h < 10 ? ('0' + hhh) : hhh;
  AMPM = (ampm = hhh < 12 ? 'am' : 'pm').toUpperCase();
  mm = (m = this.getMinutes()) < 10 ? ('0' + m) : m;
  ss = (s = this.getSeconds()) < 10 ? ('0' + s) : s;
  return formatString.replace("#hhhh#", hhhh).replace("#hhh#", hhh).replace("#hh#", hh).replace("#h#", h).replace("#mm#", mm).replace("#m#", m).replace("#ss#", ss).replace("#s#", s).replace("#ampm#", ampm).replace("#AMPM#", AMPM);
}

